export default "__VITE_ASSET__CKcbkmHQ__"